// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","copyright":"Footer_copyright__QJwUC","themeToggle":"Footer_themeToggle__ZAwbh","socialLinks":"Footer_socialLinks__7BvBL"};